import axios from "axios";
import debugLog, {LogLevel} from "../utils/debugLog";

export async function getDateByNTP() {
    const ntpUrl = axios.create({ baseURL: 'https://worldtimeapi.org' });
    return ntpUrl
        .get('/api/timezone/Asia/Singapore', {})
        .then((response: any) => {
            return {
                ...response.data,
                status: response.status,
            };
        })
        .catch((err: any) => {
            debugLog(LogLevel.ERROR, 'Unable to get internet time. ', {
                err: err,
            });
            return {
                ...err,
                status: err.response?.status || 500,
                error: err.response?.data?.message || 'Something went wrong!',
            };
        });
}